/* global process */
const env = process.env.REACT_APP_NODE_ENV || 'dev';

export default env;
